<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-card-description"
      scrollable
      centered
      button-size="sm"
      v-on:hide="hideModal"
      v-on:close="hideModal"
    >
      <template #modal-title>
        <i class="fas fa-comments"></i>&nbsp; DESCRIÇÃO DO CARD
      </template>
      <FormulateInput
        style="max-width: 100%"
        type="textarea"
        v-model="text"
        label="Digite uma descrição para o card"
        :validation="`max:${maxLength},length`"
        error-behavior="live"
        :validation-messages="{
          max: `O limite é de ${maxLength} caracteres.`
        }"
        :help="`Tamanho máximo: ${maxLength} caracteres. ${
          maxLength - text.length
        } restantes.`"
      />
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn rounded btn-default btn-sm text-secundary"
            v-on:click="onClear"
            v-b-tooltip.hover
            :title="$lang.Common.Tooltip.ButtonClear"
          >
            <i class="fa fa-minus-circle"></i>
            <span class="d-md-down-none">{{
              $lang.Common.Buttons.Clear
            }}</span></button
          >&nbsp;
          <button
            :disabled="text.length > maxLength"
            type="button"
            class="btn rounded btn-third btn-sm"
            v-on:click="onSave"
            v-b-tooltip.hover
            :title="$lang.Common.Tooltip.ButtonSave"
          >
            <i class="fa fa-check-circle"></i>
            <span class="d-md-down-none">{{
              $lang.Common.Buttons.Save
            }}</span></button
          >&nbsp;
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'ModalCardDescription',
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      text: '',
      maxLength: 32
    }
  },
  created () {
    this.onLoadCurrentDescription()
  },
  mounted () {
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-card-description'].show()
    },
    hideModal () {
      this.$emit('Reload')
    },
    onSave () {
      let newCardDetail = this.card.cardDetails
      newCardDetail.descricaoCard = this.text
      newCardDetail.cardId = this.card.id

      BoardRepositoryV2.Card_PatchDescription(
        this.card.boardColumn.board.id,
        this.card.boardColumn.id,
        this.card.id,
        newCardDetail
      )
        .then(() => {
          toast.success('A descrição foi salva com sucesso!', 'Parabéns')
        })
        .catch((e) => {
          toast.error('Não foi possível salvar a descrição.', 'Desculpe')
          console.error(e)
        })
        .finally(() => {
          this.hideModal()
        })
    },
    onLoadCurrentDescription () {
      let oldDescricaoCard = this.card.cardDetails.descricaoCard
      if (oldDescricaoCard) this.text = oldDescricaoCard
    },
    onClear () {
      this.text = ''
    }
  }
}
</script>
<style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/card-description/ModalCardDescription.vue